import { render, staticRenderFns } from "./WebCam.vue?vue&type=template&id=1fae842d&scoped=true"
import script from "./WebCam.vue?vue&type=script&lang=js"
export * from "./WebCam.vue?vue&type=script&lang=js"
import style0 from "./WebCam.vue?vue&type=style&index=0&id=1fae842d&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fae842d",
  null
  
)

export default component.exports